import { focusStylesOutline } from "../utils/focus-styles.ts";
import { cn } from "../utils/cn.ts";

export interface AgentLogoImageProps {
  agentLogoUrl: string;
  agentName: string | null | undefined;
  agentPageUrl: string | null | undefined;
  imgClassName?: string;
  linkClassName?: string;
}

export const AgentLogoImage = ({
  agentLogoUrl,
  agentName,
  agentPageUrl,
  imgClassName,
  linkClassName,
}: AgentLogoImageProps) => {
  const img = <img src={agentLogoUrl} alt={agentName ? `${agentName} logo` : "Agent logo"} className={imgClassName} />;

  return agentPageUrl ? (
    <a href={agentPageUrl} className={cn(focusStylesOutline, linkClassName)}>
      {img}
    </a>
  ) : (
    img
  );
};
